import { Brand, ShareSetting } from '@promoboxx/graphql-gateway-types'
import { useHistory } from 'react-router'

export function buildShareSettingDialogHref(
  id: ShareSetting['id'],
  brandId: Brand['id'],
) {
  const params = new URLSearchParams(window.location.search)
  params.set('shareSettingId', id)
  params.set('shareSettingBrandId', brandId)

  return `${window.location.pathname}?${params.toString()}`
}

export function useShareSettingDialog() {
  const history = useHistory()

  function openShareSettingDialog(
    id: ShareSetting['id'],
    brandId: Brand['id'],
  ) {
    const url = buildShareSettingDialogHref(id, brandId)
    // const params = new URLSearchParams(window.location.search)
    history.push(url)
  }

  return {
    openShareSettingDialog,
  }
}
